/**
 * @generated SignedSource<<69baf37dd2af17d206f85cbb7820922c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_Header_viewResult$data = {
  readonly viewConfigSettings: {
    readonly hideDone: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButton" | "hierarchyToggle_issueNavigator_HierarchyToggleItem" | "src_issueTableHideDoneToggle_HideDoneItemsToggle">;
  readonly " $fragmentType": "main_issueNavigator_Header_viewResult";
};
export type main_issueNavigator_Header_viewResult$key = {
  readonly " $data"?: main_issueNavigator_Header_viewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Header_viewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_Header_viewResult",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
    },
    {
      "kind": "FragmentSpread",
      "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SaveResetViewSettingsButton"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "staticViewInput",
          "variableName": "staticViewInput"
        }
      ],
      "concreteType": "JiraIssueSearchViewConfigSettings",
      "kind": "LinkedField",
      "name": "viewConfigSettings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "hideDone"
        }
      ]
    }
  ],
  "type": "JiraIssueSearchView"
};

(node as any).hash = "85bae304ecc16f138d9f879e49671714";

export default node;
